module.exports = __webpack_public_path__ + "img/28.ee7225ee.jpg";